import { forwardRef, useImperativeHandle, useState } from 'react';

export interface HeatmapTooltipContent {
  title: string;
  strike: string;
  label: string;
  value: string;
}

export interface HeatmapTooltipHandle {
  show: (content: HeatmapTooltipContent, clientX: number, clientY: number) => void;
  hide: () => void;
}

// Three 18px lines plus padding; keeps the tooltip on screen near the bottom rows.
const TOOLTIP_MAX_HEIGHT = 80;

interface TooltipState extends HeatmapTooltipContent {
  left: number;
  top: number;
}

export const HeatmapTooltip = forwardRef<HeatmapTooltipHandle>(function HeatmapTooltip(_, ref) {
  const [state, setState] = useState<TooltipState | null>(null);

  useImperativeHandle(ref, () => ({
    show: (content, clientX, clientY) =>
      setState({
        ...content,
        left: Math.min(clientX + 14, window.innerWidth - 170),
        top: Math.min(clientY + 14, window.innerHeight - TOOLTIP_MAX_HEIGHT),
      }),
    hide: () => setState(null),
  }));

  if (state == null) {
    return null;
  }

  return (
    <div
      role="tooltip"
      className="pointer-events-none fixed z-40 rounded-md border border-line-strong bg-[#1c1d21] px-2.5 py-2 text-xs leading-[1.5] text-fg shadow-[0_10px_24px_rgba(0,0,0,0.5)]"
      style={{ left: state.left, top: state.top }}
    >
      {state.title}
      <br />
      Strike <b className="font-mono font-medium">{state.strike}</b>
      <br />
      {state.label} <b className="font-mono font-medium">{state.value}</b>
    </div>
  );
});
